import e from "i18next";
//#region src/config/status.ts
var t = {
	completed: { color: "green" },
	pending: { color: "yellow" },
	partially_paid: { color: "violet" },
	overpaid: { color: "cyan" },
	check: { color: "red" },
	expired: { color: "gray" },
	expired_partial: { color: "orange" },
	cancelled: { color: "gray" },
	failed: { color: "red" }
}, n = {
	pending: { color: "gray" },
	detected: { color: "yellow" },
	confirming: { color: "blue" },
	confirmed: { color: "green" },
	completed: { color: "green" },
	failed: { color: "red" },
	refunded: { color: "orange" }
}, r = {
	completed: { color: "green" },
	processing: { color: "blue" },
	pending: { color: "yellow" },
	failed: { color: "red" },
	cancelled: { color: "gray" }
}, i = {
	confirmed: { color: "green" },
	pending: { color: "yellow" },
	failed: { color: "red" }
}, a = {
	ready: { color: "blue" },
	assigned_to_order: { color: "yellow" },
	payment_received: { color: "green" },
	check: { color: "orange" },
	consolidating: { color: "orange" },
	archived: { color: "gray" }
}, o = {
	active: { color: "green" },
	inactive: { color: "gray" }
}, s = {
	pending: { color: "yellow" },
	paid: { color: "blue" },
	confirmed: { color: "cyan" },
	preparing: { color: "orange" },
	ready: { color: "teal" },
	shipped: { color: "violet" },
	delivered: { color: "green" },
	cancelled: { color: "gray" }
}, c = {
	synced: { color: "green" },
	pending: { color: "yellow" },
	error: { color: "red" }
}, l = {
	in_stock: { color: "green" },
	low_stock: { color: "yellow" },
	out_of_stock: { color: "red" }
}, u = {
	pending: { color: "gray" },
	partially_paid: { color: "yellow" },
	paid: { color: "green" },
	overpaid: { color: "orange" },
	expired: { color: "gray" },
	expired_partial: { color: "orange" },
	failed: { color: "red" },
	refunded: { color: "violet" }
}, d = {
	awaiting_payment: { color: "gray" },
	confirmed: { color: "blue" },
	preparing: { color: "cyan" },
	ready: { color: "lime" },
	shipped: { color: "indigo" },
	delivered: { color: "green" },
	cancelled: { color: "red" }
}, f = {
	order: t,
	payment: n,
	withdrawal: r,
	transaction: i,
	address: a,
	merchant: o,
	merchantOrder: s,
	sync: c,
	stock: l,
	paymentStatus: u,
	fulfillmentStatus: d
}, p = {
	shop: {
		color: "blue",
		label: "merchant_type_shop"
	},
	restaurant: {
		color: "orange",
		label: "merchant_type_restaurant"
	},
	service: {
		color: "grape",
		label: "merchant_type_service"
	}
}, m = {
	users: {
		color: "blue",
		label: "Users"
	},
	roles: {
		color: "violet",
		label: "Roles"
	},
	permissions: {
		color: "grape",
		label: "Permissions"
	},
	merchants: {
		color: "teal",
		label: "Merchants"
	},
	orders: {
		color: "green",
		label: "Orders"
	},
	products: {
		color: "orange",
		label: "Products"
	},
	payments: {
		color: "cyan",
		label: "Payments"
	},
	settings: {
		color: "gray",
		label: "Settings"
	},
	addresses: {
		color: "indigo",
		label: "Addresses"
	},
	api_keys: {
		color: "red",
		label: "API Keys"
	},
	blockchain: {
		color: "yellow",
		label: "Blockchain"
	},
	cart: {
		color: "pink",
		label: "Cart"
	}
}, h = {
	system: {
		color: "blue",
		label: "System"
	},
	custom: {
		color: "gray",
		label: "Custom"
	}
}, g = {
	personal: {
		color: "blue",
		label: "Personal"
	},
	merchant: {
		color: "teal",
		label: "Merchant"
	},
	system: {
		color: "gray",
		label: "System"
	}
}, _ = {
	reuse: {
		color: "blue",
		label: "Reuse"
	},
	unique: {
		color: "violet",
		label: "Unique"
	}
}, v = {
	merchant: p,
	resource: m,
	role: h,
	addressContext: g,
	paymentMode: _
}, y = [
	{
		value: 4.5,
		color: "green",
		label: "Excellent"
	},
	{
		value: 4,
		color: "blue",
		label: "Very Good"
	},
	{
		value: 3.5,
		color: "orange",
		label: "Good"
	},
	{
		value: 0,
		color: "red",
		label: "Fair"
	}
], b = [{
	value: 19,
	color: "green",
	label: "Confirmed"
}, {
	value: 0,
	color: "yellow",
	label: "Confirming"
}], x = [
	{
		value: 50,
		color: "green",
		label: "Healthy"
	},
	{
		value: 20,
		color: "yellow",
		label: "Moderate"
	},
	{
		value: 0,
		color: "red",
		label: "Low"
	}
], S = [
	{
		value: 1,
		color: "yellow",
		label: "Gold"
	},
	{
		value: 2,
		color: "gray",
		label: "Silver"
	},
	{
		value: 3,
		color: "orange",
		label: "Bronze"
	}
], C = [
	{
		value: 50,
		color: "green",
		label: "Sufficient"
	},
	{
		value: 10,
		color: "yellow",
		label: "Low"
	},
	{
		value: 0,
		color: "red",
		label: "Critical"
	}
], w = [
	{
		value: 90,
		color: "red",
		label: "Critical"
	},
	{
		value: 70,
		color: "orange",
		label: "Warning"
	},
	{
		value: 0,
		color: "green",
		label: "Normal"
	}
], T = {
	color: "gray",
	label: "Unknown"
};
function E(e, t) {
	let n = f[e];
	return n ? n[t] ?? T : T;
}
function D(e, t) {
	return E(e, t).color;
}
function O(e, t) {
	return E(e, t).label ?? String(t).replace(/_/g, " ");
}
var k = {
	paymentStatus: { prefix: "payment_status" },
	fulfillmentStatus: { prefix: "fulfillment_status" }
};
function A(t, n) {
	let r = `${k[t]?.prefix ?? `status.${t}`}.${n}`, i = e.t(r);
	if (i !== r) return i;
	let a = `common.${r}`;
	return i = e.t(a), i === a ? String(n).replace(/_/g, " ") : i;
}
function j(e, t) {
	let n = v[e];
	return n ? n[t] ?? T : T;
}
function M(e, t) {
	return j(e, t).color;
}
function N(e, t) {
	return j(e, t).label ?? String(t).replace(/_/g, " ");
}
function P(t, n) {
	let r = `category.${t.replace(/([A-Z])/g, "_$1").toLowerCase()}.${n}`, i = e.t(r, { ns: "common" });
	return i === r ? String(n).replace(/_/g, " ") : i;
}
function F(e, t) {
	for (let n of t) if (e >= n.value) return n.color;
	return "gray";
}
function I(e, t) {
	for (let n of t) if (e >= n.value) return n.label;
}
function L(t) {
	let n = `level.${t.toLowerCase().replace(/\s+/g, "_")}`, r = e.t(n);
	if (r !== n) return r;
	let i = `common.${n}`;
	return r = e.t(i), r === i ? t : r;
}
function R(e, t) {
	for (let n of t) if (e >= n.value) return n;
}
//#endregion
//#region src/config/notifications.ts
var z = {
	position: "bottom-right",
	zIndex: 1e3,
	autoClose: 5e3,
	containerWidth: 350,
	limit: 5
}, B = {
	success: "green",
	error: "red",
	warning: "orange",
	info: "blue"
}, V = "es-AR", H = [
	"es-AR",
	"en-US",
	"pt-BR"
], U = "ARS", W = {
	ARS: {
		symbol: "$",
		locale: "es-AR",
		decimals: 2
	},
	USD: {
		symbol: "US$",
		locale: "en-US",
		decimals: 2
	},
	USDT: {
		symbol: "USDT",
		locale: "en-US",
		decimals: 2
	}
};
//#endregion
export { m as A, l as B, y as C, v as D, g as E, o as F, i as H, u as I, t as L, a as M, d as N, p as O, s as P, n as R, S, w as T, r as U, c as V, D as _, z as a, C as b, M as c, F as d, I as f, A as g, L as h, H as i, h as j, _ as k, j as l, P as m, U as n, B as o, R as p, V as r, T as s, W as t, N as u, E as v, x as w, b as x, O as y, f as z };

//# sourceMappingURL=config-DT7lPKdp.js.map